const removeUploadedUsers = (localStorage, key) => {
  localStorage.removeItem(key);
};

export default removeUploadedUsers;
